import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          campaignBanners ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              title,
              description,
              cta_label,
              image_url,
              destination_url,
              activated,
              created_at,
              updated_at,
              position,
              direction,
              clicks_qty
            }
          }
        }
      `
    })
  },
  add(campaign) {
    return axios.post('', {
      query: `
        mutation {
          createCampaignBanner ${paramsObjToGraphQLParams(campaign)} {
            id,
            title,
            description,
            cta_label,
            image_url,
            destination_url,
            activated,
            created_at,
            updated_at,
            position,
            direction,
            clicks_qty
          }
        }
      `
    })
  },
  update(campaign) {
    return axios.post('', {
      query: `
        mutation {
          updateCampaignBanner ${paramsObjToGraphQLParams(campaign)} {
            id,
            title,
            description,
            cta_label,
            image_url,
            destination_url,
            activated,
            created_at,
            updated_at,
            position,
            direction,
            clicks_qty
          }
        }
      `
    })
  },
  delete(campaignId) {
    return axios.post('', {
      query: `
        mutation {
          deleteCampaignBanner (
            id: ${campaignId}
          )
        }
      `
    })
  },
  infos(campaignId) {
    return axios.post('', {
      query: `
        query {
          campaignBannerInfos (
            id: ${campaignId}
          ) {
            id,
            title,
            description,
            cta_label,
            image_url,
            destination_url,
            activated,
            created_at,
            updated_at,
            position,
            direction,
            clicks_qty
          }
        }
      `
    })
  },
  lastNews() {
    return axios.post('', {
      query: `
        query {
          news (
            activated: true,
            order_by: "updated_at_desc",
            pagination_page: 1,
            pagination_limit: 1
        ) {
            items {
              id,
              slug,
              category {
                slug
              },
              created_at_sliced {
                day,
                month,
                year,
              }
            }
          }
        }
      `
    })
  },
}
